module.exports = __webpack_public_path__ + "static/media/Blou 10.e996e0c2.png";